import moment from "moment";

class models {
  constructor(id, groupId, from, to, name) {
    this.id = id;
    this.groupId = groupId;
    this.from = moment(from).utc().format("DD-MM-YYYY");
    this.to = to == null ? "" : moment.utc(to).format("DD-MM-YYYY");
    this.name = name;
  }

  static fromJson({ liqModeloId, grupoId, fecDesde, fecHasta, nomLiqModelo }) {
    return new models(liqModeloId, grupoId, fecDesde, fecHasta, nomLiqModelo);
  }
}

export default models;
